import { render, staticRenderFns } from "./EditMemberRecordCategoryView.vue?vue&type=template&id=f0ce040e"
import script from "./EditMemberRecordCategoryView.vue?vue&type=script&lang=ts"
export * from "./EditMemberRecordCategoryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports